import React, { useState, useEffect } from "react";

import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import DatePicker from "material-ui/DatePicker";
import CalIcon from "material-ui/svg-icons/action/date-range";
import TextField from "@material-ui/core/TextField";

import RTMService from "../../services/rtm";
import colors from "../../styles/colors";

export default (props) => {
  const [selectedCappId, setSelectedCappId] = useState(null);
  const [interactionDate, setInteractionDate] = useState(new Date());
  const [interactionType, setInteractionType] = useState(
    props.fromChart ? "Monitoring Time" : null
  );
  const [interactionDescription, setInteractionDescription] = useState("");
  const [interactionLength, setInteractionLength] = useState(null);
  const [requiredFieldMsg, setRequiredFieldMsg] = useState("");
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(props.showPopup);
  }, [props.showPopup]);

  useEffect(() => {
    setSelectedCappId(props.customAppId);
  }, [props.customAppId]);

  const clear = () => {
    setSelectedCappId(null);
    setInteractionDate(new Date());
    setInteractionType(props.fromChart ? "Monitoring Time" : null);
    setInteractionDescription("");
    setInteractionLength(null);
    setRequiredFieldMsg("");
    setShow(false);
  };

  return (
    <Dialog
      title={"Log Interaction With Patient"}
      actions={[
        <FlatButton
          label="Cancel"
          onClick={() => {
            clear();
            props.setShowPopup(false);
          }}
        />,
        <FlatButton
          label="Save"
          primary={true}
          onClick={() => {
            setRequiredFieldMsg("");
            let canSubmit = true;
            if (interactionDate == null) {
              setRequiredFieldMsg("You must select a date before saving");
              canSubmit = false;
            }
            if (interactionType == null) {
              setRequiredFieldMsg(
                "You must select an interaction type before saving"
              );
              canSubmit = false;
            }
            if (interactionLength == null) {
              setRequiredFieldMsg(
                "You must select the length of the interaction before saving"
              );
              canSubmit = false;
            }
            if (interactionDescription.trim().length < 1) {
              setRequiredFieldMsg("You must enter a description before saving");
              canSubmit = false;
            }

            if (canSubmit) {
              RTMService()
                .addInteraction(
                  selectedCappId,
                  interactionDate,
                  interactionType,
                  interactionDescription,
                  interactionLength
                )
                .then((resp) => {
                  if (resp.resp === "ok") {
                    if (!props.fromChart) {
                      alert("Interaction logged successfully");
                      props.updateRow(selectedCappId, interactionLength);
                    }
                    clear();
                    props.setShowPopup(false);
                    if (props.fromChart) {
                      props.navBack();
                    }
                  }
                });
            }
          }}
        />,
      ]}
      modal={true}
      open={show}
      onRequestClose={() => {
        clear();
        props.setShowPopup(false);
      }}
      style={{ width: 650, marginLeft: "40%" }}
    >
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          margin: 20,
          justifyContent: "left",
          justifyItems: "left",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <span style={{ fontSize: 16, color: colors.accent, padding: 2 }}>
            Date Of Interaction
          </span>
          <DatePicker
            id="interactionDate"
            label="Date Of Interaction"
            defaultDate={interactionDate}
            maxDate={new Date()}
            hideCalendarDate={true}
            onChange={(event, date) => {
              setInteractionDate(date);
            }}
            style={{
              maxWidth: "100%",
              fontSize: 16,
              fontWeight: 600,
              height: 35,
              width: 400,
            }}
          />
          <CalIcon />
        </div>
        <SelectField
          floatingLabelText="Type Of Interaction"
          floatingLabelStyle={{ color: colors.accent }}
          value={interactionType}
          onChange={(event, index, value) => {
            setInteractionType(value);
          }}
          style={{
            width: 400,
          }}
        >
          {!props.fromChart && (
            <MenuItem key={0} value={"Phone Call"} primaryText={"Phone Call"} />
          )}
          {!props.fromChart && (
            <MenuItem key={1} value={"Video Call"} primaryText={"Video Call"} />
          )}
          <MenuItem
            key={2}
            value={"Monitoring Time"}
            primaryText={"Monitoring Time"}
          />
        </SelectField>
        <SelectField
          floatingLabelText="Length Of Interaction"
          floatingLabelStyle={{ color: colors.accent }}
          value={interactionLength}
          onChange={(event, index, value) => {
            setInteractionLength(value);
          }}
          style={{
            width: 400,
          }}
        >
          <MenuItem key={0} value={5} primaryText={"5 Min."} />
          <MenuItem key={0} value={10} primaryText={"10 Min."} />
          <MenuItem key={0} value={15} primaryText={"15 Min."} />
          <MenuItem key={1} value={30} primaryText={"30 Min."} />
          <MenuItem key={2} value={45} primaryText={"45 Min."} />
          <MenuItem key={3} value={60} primaryText={"1 hr."} />
          <MenuItem key={4} value={90} primaryText={"1.5 hr."} />
          <MenuItem key={5} value={120} primaryText={"2 hr."} />
        </SelectField>
        <TextField
          id="interactionDescription"
          label="Description"
          variant="outlined"
          value={interactionDescription}
          multiline={true}
          minRows={3}
          maxRows={7}
          maxLength={4000}
          required={true}
          style={{
            width: 400,
            margin: 20,
          }}
          onChange={(e) => {
            setInteractionDescription(e.target.value);
          }}
        />
        <span style={{ color: "red" }}>{requiredFieldMsg}</span>
      </div>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/components/rtm/LogInteractionPopup.js